import { IApplicationState } from '../../../../../../types/types';
import { getMentionSubstring } from './getMentionSubstring';

export const isMentionsDropDownShown = (state: IApplicationState) => {
    return Boolean(getMentionSubstring(state));
}
